import { HeroSection } from '@/components/home/HeroSection';
import { SocialProofSection } from '@/components/home/SocialProofSection';
import { ProblemSection } from '@/components/home/ProblemSection';
import { FeaturesSection } from '@/components/home/FeaturesSection';
import { HowItWorksSection } from '@/components/home/HowItWorksSection';
import { ThemeShowcaseSection } from '@/components/home/ThemeShowcaseSection';
import { BenefitsSection } from '@/components/home/BenefitsSection';
import { DemoSection } from '@/components/home/DemoSection';
import { FAQSection } from '@/components/home/FAQSection';
import { FinalCTASection } from '@/components/home/FinalCTASection';

const Home = () => {
  return (
    <>
      <HeroSection id="app" />
      <SocialProofSection />
      <ProblemSection />
      <FeaturesSection id="features" />
      <HowItWorksSection />
      <ThemeShowcaseSection />
      <BenefitsSection />
      <DemoSection />
      <FAQSection id="faq" />
      <FinalCTASection />
    </>
  );
};

export default Home;
